import { render, staticRenderFns } from "./DisplayImage.vue?vue&type=template&id=ecdc8684&scoped=true&"
import script from "./DisplayImage.vue?vue&type=script&lang=js&"
export * from "./DisplayImage.vue?vue&type=script&lang=js&"
import style0 from "./DisplayImage.vue?vue&type=style&index=0&id=ecdc8684&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdc8684",
  null
  
)

export default component.exports